import { render, staticRenderFns } from "./NewEditClientView.vue?vue&type=template&id=a1f8d55e&scoped=true"
import script from "./NewEditClientView.vue?vue&type=script&lang=ts"
export * from "./NewEditClientView.vue?vue&type=script&lang=ts"
import style0 from "./NewEditClientView.vue?vue&type=style&index=0&id=a1f8d55e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f8d55e",
  null
  
)

export default component.exports